// Commercial flags — flip these to re-enable selling later.
export const SHOP_COMING_SOON = true;    // one-time shop products ("book", "ebook", "program")
export const BOOKING_PAID_ENABLED = false; // only free discovery call when false
export const SUBSCRIPTIONS_COMING_SOON = true; // show "Bientôt disponible" on subscription CTAs
// The Nordicvy monthly review (revue_unit) remains available because its PDF has been approved.
